import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig, GOOGLE_MAPS_API_CONFIG_TOKEN } from './google-maps-settings.config';

@Injectable()
export class GoogleMapsSettingsRepository {
  constructor(
    @Inject(GOOGLE_MAPS_API_CONFIG_TOKEN) private config: ApiConfig,
    private http: HttpClient,
  ) {}

  lazyLoadAPI(configKey?: string): Observable<any> {
    const selectedLanguage = localStorage.getItem('language');
    return this.http.jsonp(
      `https://maps.googleapis.com/maps/api/js?key=${configKey ?? this.config.apiKey}&libraries=places&language=${
        selectedLanguage ?? 'en'
      }`,
      'callback',
    );
  }
}
